import React from 'react';

import { FetchStatus } from '@tanstack/react-query';
import { useTrackingContext } from 'src/context/TrackingContext';

import { MappedCongestionDataProps } from '../types/mappedResponse';
import { WIZARD_NAME } from '../constant/constant';

type useWizardTrackingProps = {
  fetchStatus: FetchStatus;
  data?: MappedCongestionDataProps & { response: string | null | undefined };
  isError: boolean;
};

export const useWizardTracking = ({ fetchStatus, data, isError }: useWizardTrackingProps) => {
  const { trackWizardSimpleChange, trackCustomWizard } = useTrackingContext();

  React.useEffect(() => {
    if (fetchStatus === 'fetching') return;

    if (data?.response) {
      // We keep track of the output of the api, the action name is a bit weird but the guys form tracking wanted to name it this way.
      trackCustomWizard({
        action: 'close wizard',
        actionDetail: `${WIZARD_NAME}: presenteren output wizard`,
        wizardName: WIZARD_NAME,
        wizardStep: 2.1,
        wizardOutput: data.response || '',
      });
    }
  }, [fetchStatus, data, isError, trackWizardSimpleChange, trackCustomWizard]);
  return { WIZARD_NAME };
};
